export default {
  ManuallyByBackoffice: "manuallyByBackoffice",
  AutoNewUser: "autoPromotionNewUser",
  AutoBirthday: "autoPromotionBirthday",
  AutoNearbyLocation: "autoPromotionNearbyLocation",
  AutoLanguage: "autoPromotionLanguage",
  AutoConnectedUser: "AutoConnectedUser",
};
